import { authRequest } from './client';
import {
  type ListLedgersParams,
  type ListLedgersResponse,
  type ListLedgerTransactionsResponse,
} from './types';

// Task 28 Part A: global (all-merchant) ledger reads, FINANCE_VIEWER-gated —
// `services/backoffice-api/src/ledgers/` mirrored exactly.

export function listLedgers(params: ListLedgersParams = {}): Promise<ListLedgersResponse> {
  const query = new URLSearchParams();
  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.sortBy !== undefined) query.set('sortBy', params.sortBy);
  if (params.sortOrder !== undefined) query.set('sortOrder', params.sortOrder);
  if (params.merchantId !== undefined) query.set('merchantId', params.merchantId);
  if (params.network !== undefined) query.set('network', params.network);
  if (params.status !== undefined) query.set('status', params.status);
  const qs = query.toString();
  return authRequest<ListLedgersResponse>(`/ledgers${qs ? `?${qs}` : ''}`);
}

export function getLedgerTransactions(
  type: 'merchant' | 'project',
  ledgerId: string,
  params: { page?: number; pageSize?: number } = {},
): Promise<ListLedgerTransactionsResponse> {
  const query = new URLSearchParams();
  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  const qs = query.toString();
  return authRequest<ListLedgerTransactionsResponse>(`/ledgers/${type}/${ledgerId}/transactions${qs ? `?${qs}` : ''}`);
}
